var _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _mask5, _g5, _mask6, _g6, _mask7, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScar = function SvgScar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__a",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4B4B4B",
    fillRule: "evenodd",
    d: "M33.197 18.254c0 8.615-6.983 15.599-15.598 15.599S2 26.869 2 18.254 8.984 2.656 17.6 2.656s15.598 6.983 15.598 15.598",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__b",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "m32.269 36.435-1.042-11.881H18.312l-1.043 11.881.013.017c3.6 5.267 11.372 5.268 14.974.002z",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__c",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "M24.814 31.97c-2.308 0-4.408-.53-6.244-1.572a.55.55 0 0 1 .545-.957c1.667.947 3.585 1.428 5.699 1.428 2.221 0 4.223-.53 5.947-1.574a.55.55 0 1 1 .571.942c-1.9 1.15-4.092 1.733-6.518 1.733",
    clipRule: "evenodd"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__d",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M6.536 15.558c.503 2.37 2.465 3.96 4.383 3.554s3.067-2.657 2.565-5.026c-.503-2.37-2.465-3.96-4.383-3.554-1.92.406-3.068 2.656-2.565 5.026",
    clipRule: "evenodd"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__e",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    fillRule: "evenodd",
    d: "M12.086 15.04a.55.55 0 0 1-.538-.438 2.14 2.14 0 0 0-.77-1.267c-.363-.277-.778-.382-1.178-.299-.47.1-.855.454-1.054.97a.551.551 0 0 1-1.028-.4c.334-.854 1.026-1.471 1.854-1.646.717-.153 1.453.024 2.075.5a3.25 3.25 0 0 1 1.179 1.915.55.55 0 0 1-.54.664",
    clipRule: "evenodd"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__f",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scar_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M37.157 20.397q.045-.17.086-.341c.518-2.096 2.27-9.681 1.62-14.013C38.107.983 33.768-6.258 24.77-6.258c-8.999 0-13.336 7.24-14.094 12.3-.649 4.333 1.103 11.92 1.62 14.014l.085.338.055.212a18 18 0 0 0 1.078 2.947c2.651 5.662 6.993 7.554 11.256 7.554 4.264 0 8.606-1.892 11.257-7.554.444-.952.803-1.938 1.077-2.947z",
    clipRule: "evenodd"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "scar_svg__g",
    width: 32,
    height: 32,
    x: 2,
    y: 2,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2 18.254c0 8.615 6.984 15.598 15.599 15.598s15.598-6.983 15.598-15.598S26.214 2.655 17.6 2.655 2 9.64 2 18.254",
    clipRule: "evenodd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#scar_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M11.617 17.56a.6.6 0 0 1-.202-.04c-.064-.025-1.563-.642-1.951-2.476-.403-1.9.858-2.812.912-2.85a.55.55 0 0 1 .639.897c-.04.031-.719.566-.474 1.725.263 1.242 1.244 1.665 1.286 1.683a.553.553 0 0 1-.21 1.06"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF773D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.506 25.783-.791-.463c-4.484-2.622-5.57-4.99-6.433-9.643l-.168-.903 1.805-.334.168.902c.744 4.013 1.496 6.021 5.553 8.394l.793.462z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.273 22.664a.92.92 0 0 1-.698-1.512 7.6 7.6 0 0 1 2.052-1.68.917.917 0 0 1 .845 1.629c-.028.015-.823.444-1.5 1.24a.92.92 0 0 1-.7.323M16.608 18.923a.918.918 0 0 1-.516-1.678c1.186-.803 2.376-1.06 2.426-1.07a.918.918 0 0 1 .382 1.794c-.01.002-.901.202-1.779.796a.9.9 0 0 1-.513.158M20.963 25.403a.917.917 0 0 1-.826-1.316c.62-1.29 1.518-2.11 1.556-2.145a.917.917 0 0 1 1.233 1.359 5.8 5.8 0 0 0-1.136 1.583.92.92 0 0 1-.828.519"
  })))));
};
export default SvgScar;